<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [limitedTo]="themeOptions.limitedTo(optionType)">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <app-number [color]="color" [value]="themeOptions.axes(axesXY, axesIndex)['minBarHeight'] || 0" (sendValue)="receiveValue($event)" [min]="0" [max]="30" [step]="5"></app-number>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">
  <app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [label]="type | chart" [dark]="4" *ngFor="let type of themeOptions.limitedTo(optionType)">
    <div app-theme-option-content>
      <app-number [color]="color" [value]="themeOptions.axes(axesXY, axesIndex, type)['minBarHeight'] || 0" (sendValue)="receiveValue($event, type)" [min]="0" [max]="30" [step]="5"></app-number>
    </div>
  </app-theme-option>
</div>